var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardCiti = function SvgCardCiti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "card-citi_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40 40"
    }
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".card-citi_svg__st2{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
    style: {
      fill: "#0281c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.295.295 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582zm3.53-.768c0-.163.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .163.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4da7d5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.737 15.695-.019.019c-.302.307-.651.47-1.01.47-.751 0-1.296-.563-1.296-1.341 0-.776.545-1.34 1.296-1.34.36 0 .709.163 1.01.472l.019.018.483-.584-.013-.016c-.402-.475-.884-.705-1.476-.705-.594 0-1.138.2-1.529.561-.426.391-.65.942-.65 1.595 0 .652.224 1.205.65 1.596.391.361.935.56 1.529.56.592 0 1.075-.231 1.476-.706l.013-.014-.483-.585zM30.707 16.921h.853v-4.165h-.853v4.165zM34.903 16.015c-.228.139-.439.209-.63.209-.276 0-.401-.146-.401-.47v-2.21h.87v-.784h-.87v-1.296l-.836.448v.848h-.722v.784h.722v2.351c0 .64.379 1.079.946 1.09a1.34 1.34 0 0 0 .757-.191l.009-.006.205-.803-.05.03zM35.609 16.921h.854v-4.165h-.854v4.165z",
    className: "card-citi_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.962 12.025a4.196 4.196 0 0 0-3.391-1.763 4.192 4.192 0 0 0-3.389 1.763l-.04.057h.982l.011-.012c.668-.69 1.54-1.054 2.437-1.054s1.769.364 2.438 1.054l.011.012h.981l-.04-.057z",
    style: {
      fill: "#ee1c25"
    }
  }));
};
export default SvgCardCiti;